import { Link, Stack, Tooltip, Typography } from '@mui/material';

export const TableTemplateCell = ({
    title,
    subtitle,
    subtitleButton,
    subtitleButtonClick,
    subtitleButtonDisabled = false,
    subtitleButtonTooltip = '',
    titleSize = 'body1',
    subtitleSize = 'caption',
    fontWeight = 'normal',
    spacing = 0.5,
}: {
    title?: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    subtitleButton?: string | React.ReactNode;
    subtitleButtonClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    subtitleButtonDisabled?: boolean;
    subtitleButtonTooltip?: string;
    titleSize?: 'body1' | 'body2' | 'h6';
    subtitleSize?: 'caption' | 'body2' | 'subtitle2';
    fontWeight?: 'bold' | 'normal';
    spacing?: number;
}) => {
    return (
        <Stack direction='column' spacing={spacing}>
            {title && (
                <Typography variant={titleSize} color='primary' fontWeight={fontWeight}>
                    {title}
                </Typography>
            )}
            {subtitle && (
                <Typography variant={subtitleSize} color='primary.mui.inactive' sx={{ whiteSpace: 'pre-line' }}>
                    {subtitle}
                </Typography>
            )}
            {subtitleButton && (
                <Tooltip title={subtitleButtonTooltip} arrow>
                    <Link
                        component='button'
                        variant='caption'
                        color={subtitleButtonDisabled ? 'primary.mui.inactive' : 'secondary'}
                        onClick={subtitleButtonClick}
                        sx={{ alignSelf: 'flex-start', opacity: subtitleButtonDisabled ? 0.5 : 1 }}
                        disabled={subtitleButtonDisabled}
                    >
                        {subtitleButton}
                    </Link>
                </Tooltip>
            )}
        </Stack>
    );
};
